import React, {useEffect} from 'react';
import Nav from '../../Page Components/Nav';
import Footer from "../../Page Components/Footer";
import Card from "../../Co Components/SquareCards";
import Square from "../../Co Components/SquareCards";
import Title from "../../Co Components/Titles";
import homehero from '../../assets/Images/homehero.png';
import Rectangle from "../../Co Components/RectangleCards";
import LineButton from "../../Co Components/LineButton";
import hackerYellow from '../../assets/Images/hacker copy.png';
import BlogCard from "../../Co Components/BlogCards";
import HomeCard from "../../Co Components/HomeCards";
import PrimaryButton from "../../Co Components/PrimaryButton";
import SecondaryButton from "../../Co Components/SecondaryButton";
const SOC = () => {
useEffect(() => {
        window.scrollTo(0, 0)


    });
    return (
        <>

            <Nav />
            <section className={' d-flex flex-row mt-0  align-items-center w-90 '}>
                <article>
                    <div className={'mx-5 w-75'}>
                        <h1 className={'bebas display-1 text-black bolde  line-normal'}>WhiteGuard
                            <span className={'bebas yellow'}><br /> SOC As A Service</span><br />
                            Services</h1>
                    </div>

                    <div className={'w-75 mx-5'}>
                        <p className={'bolder h6'} >
                        Our Security Operations Centre (SOC-as-a-Service)
provides innovative, advanced managed threat detection and incident
response solutions to protect your business from emerging cyber threats
while ensuring regulatory compliance and reducing the cost of managing
and operating the Security Operations Centre.
                        </p>
                    </div>
                </article>
                <figure className=' headerImage align-self-center d-flex flex-column w-25'>
                    <HomeCard className={'info'} />
                    <img src={hackerYellow} className={'hackerImage z-1'} />
                </figure>

            </section>

            <Title className={'mt-6'} header={"the"} body={"Benefits"} />
            <div className={'d-flex mb-5 flex-row justify-content-center align-items-center flex-wrap'}>
                <Square className={'mx-4 cardYellow mt-5'} Title={"24/7 Monitoring and Response"} text={'Cyber threats can arise at any time, and prompt detection and \n' +
                    'response are crucial to mitigating potential damages. SOC as a Service \n' +
                    'providers offer round-the-clock monitoring and incident response \n' +
                    'capabilities, ensuring that security incidents are addressed promptly. \n' +
                    'This continuous vigilance helps to minimize the impact of potential \n' +
                    'breaches or attacks.'} />
                <Square className={'mx-4 cardYellow mt-5'} Title={"Faster Detection and Remediation"} text={'Speed is one of the most important benefits of having SOCaaS. With the help of a combination of advanced technology and automation, as well as human oversight, the SOCaaS team can properly identify, prioritize, categorize as well as remediate security events. It is really a tough task for companies to minimize the amount of time spent investigating “false alarms” and concentrate on real as well as urgent threats to the business as the number of alerts continues to rise.'} />
                <Square className={'mx-4 cardYellow mt-5'} Title={"Lower Risk for a Breach "} text={'SOCaaS works constantly, offering 24/7/365 monitoring, detection, and response capabilities. This assists enterprises in ensuring that threats are contained as well as neutralized quickly, which in turn results in reducing the “breakout time” for them.'} />
                <Square className={'mx-4 cardYellow mt-5'} Title={"Resource optimization "} text={'SOCaaS helps in solving the challenge related to the availability of the workforce as well as frees up employees to focus on security use cases that are more important for in-house roles as attracting and retaining talent has become more difficult.'}/>

                <Square className={'mx-4 cardYellow mt-5'} Title={"Cost-effectiveness "} text={'Building and maintaining an in-house SOC requires substantial investments in infrastructure, staffing, and training. SOC as a Service allows businesses to leverage the expertise and infrastructure of the service provider at a fraction of the cost. This cost-effective approach makes security operations more accessible to organizations with limited budgets.'} />
                <Square className={'mx-4 cardYellow mt-5'} Title={"Scalability and Flexibility "} text={'As businesses grow, their security needs evolve as well. SOC as a Service providers offer scalable solutions that can adapt to changing business requirements. Whether you need to expand your security capabilities or downsize during lean periods, a flexible SOC as a Service model allows you to easily adjust your security operations without significant investments or disruptions.'} />
            </div>
            <Title className={'mt-6'} header={"the"} body={"Process"} />
            <div className={'d-flex mb-12 flex-column align-items-center justify-content-start process-container'} style={{ transition: 'all 0.3s ease' }}>
                <Rectangle className={'mt-4 cardYellow'} Title={'Identification of Potential Security Threats'} text={'This process involves monitoring network traffic, system logs, and other \n' +
                    'data sources to identify potential security threats. This can include \n' +
                    'suspicious login attempts, network anomalies, or unauthorized access \n' +
                    'attempts.'} />
                <Rectangle className={'mt-4 cardYellow'} Title={'Prevention of Security Threats'} text={'SOC teams use various techniques to prevent security threats, such as \n' +
                    'access controls, firewalls, and intrusion prevention systems. They also \n' +
                    'work with other teams within the organization to ensure that security \n' +
                    'policies and procedures are followed.'} />
                <Rectangle className={'mt-4 cardYellow'} Title={'Detection of Security Threats'} text={'Once a potential security threat has been identified, SOC teams use various \n' +
                    'tools and techniques to detect and analyze the threat. This includes \n' +
                    'network monitoring, threat intelligence, and endpoint detection and \n' +
                    'response (EDR) tools.'} />
                <Rectangle className={'mt-4 cardYellow'} Title={'Response to Security Threats'} text={'Once a security threat has been detected, SOC teams must respond quickly and\n' +
                    ' effectively to contain the threat and minimize the damage. This can \n' +
                    'involve blocking network traffic, isolating infected systems, and \n' +
                    'disabling compromised accounts.'} />
                <Rectangle className={'mt-4 cardYellow'} Title={'Recovery From Security Threats'} text={'After a security incident has been contained and resolved, SOC teams must \n' +
                    'work to restore systems and data to their normal state. This includes \n' +
                    'data restoration, system patching, and user account recovery.'} />
            </div>


            <Footer />
        </>
    );

}

export default SOC;